<template lang="pug">
  .AK-List_Users
    users-list-item(
      v-for="user in users",
      :key="user.id",
      :user="user",
      :user-data="user.id | getUserDataById(usersData)",
    )
</template>
<script>
  import UsersListItem from 'modules/components/Event/AkiyaKatsuyou/UsersListItem.vue';

  export default {
    components: {
      UsersListItem,
    },
    filters: {
      getUserDataById(id, data) {
        return data.find((d) => d.id === id);
      },
    },
    props: {
      users: {
        type: Array,
        required: true,
      },
      usersData: {
        type: Array,
        required: true,
      },
    },
  };
</script>
